export const BACKEND_URL = "https://promanage-backend-1.onrender.com/api";
export const FRONTEND_URL = "https://promanagecuvette.netlify.app";
